<script setup>
  import { useSheetController } from '@/composables/useSheetsController';

  function closeSheet() {
    useSheetController.closeAllSheets()
  }  
</script>

<template>
  <Transition name="sheet-backdrop">
    <div
      v-if="useSheetController.showSheetBackdrop"
      @click="closeSheet"
      class="jwx-sheet-backdrop"
    ></div>
  </Transition>
</template>